module.exports = __webpack_public_path__ + "img/Chest_rates_vertical.bc907636.png";